"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var styles = _interopRequireWildcard(require("./Container.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Container = _ref => {
  let {
    fields,
    programs,
    banner,
    title,
    subtitle
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading1, {
    as: "h2"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-24']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-24']
  }, fields), /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-24']
  }, programs), /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-16']
  }, banner), /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-16']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "gray60_100"
  }, "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u043E\u0441\u0438\u0442 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440 \u0438 \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u043E\u0439")));
};
exports.Container = Container;